


import store from '@/store'

const DEFAUL_ROUTE = {
  name: 'Siniestros Carreteros'
}

const groupRoutes = {
  KAM: {
    name: 'Siniestros Carreteros Pendientes Validacion Comercial',
  },
  EXCLI: {
    name: 'Aprobacion de siniestros',
  },
  IDEAL: {
    name: 'Reporte de Fechas',
  },
  Extranet: {
    name: 'Estatus Siniestros'
  },
  Extranet_GeRe: {
    name: 'Estatus Siniestros'
  },
  Extranet_JeAd: {
    name: 'Estatus Siniestros'
  },
  Extranet_JeCo: {
    name: 'Estatus Siniestros'
  },
  Extranet_JeEl: {
    name: 'Estatus Siniestros'
  }
}

function redirectGroup(to) {
  const { hash, params, query } = to
  const userGroup = store.getters['account/userAccountInGroup']
  let goTo = DEFAUL_ROUTE

  const pos = Object.entries(groupRoutes)
    .find(([ group, route  ]) => userGroup(group))

  if (pos) {
    const [ group, route ] = pos
    goTo = route
  }
  return goTo
}

export default redirectGroup



// WEBPACK FOOTER //
// ./src/router/groupRouting.js